//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
export default {
  name: "TeamMemberDesComponent",
  data() {
    const _this = this;
    return {
      memberDes: [
        _this.$t("inviteMemberPage.des5"),
        _this.$t("inviteMemberPage.des7"),
        _this.$t("inviteMemberPage.des8"),
        _this.$t("inviteMemberPage.des9"),
      ],
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/team_member/des2/Index.vue